/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_GenericInputs */



/**
* | output |
* | --- |
* | "Something went wrong. Try again." |
*
* @param {Login_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_error_generic = /** @type {((inputs?: Login_Error_GenericInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_GenericInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er ging iets mis. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur est survenue. Réessayez.")
	return /** @type {LocalizedString} */ ("Something went wrong. Try again.")
});